export const PriceModeEnum = {
  TICKET_PRICE: 'TICKET_PRICE',
  FULL_PRICE: 'FULL_PRICE',
}

export const ReportProductTypeEnum = {
  EVENT: 'EVENT',
  PERFORMANCE: 'PERFORMANCE',
  VISIT: 'VISIT',
  TIMESLOT_MONTH: 'TIMESLOT_MONTH',
  TIMESLOT: 'TIMESLOT',
  OPEN_PASS: 'OPEN_PASS',
  TOUR: 'TOUR',
}

export const NO_TOUR = 'No tour';

export const NO_TOUR_ID = 0;

/* Const for checking selected product's level in tour dashboard
* TOUR level:
* is when there tour items (events, visits, open passes) are all selected and all items of unselected tour(s) must be unselected
*
* PRODUCT level:
* is when there are some items (events, visits, open passes) in unselected tour/NO tour and all performance/month timeslots of unselected events/visits must be unselected.
*
* PERFORMANCE level:
* is when there are some performance in unselected events and all date timeslot of unselected visits must be unselected
*
* TIMESLOT level:
* is when there are some date timeslots in unselected visits.
*/
export const TOUR_REPORT_LEVEL_ENUM = {
  'TIMESLOT': 0,
  'PERFORMANCE': 1,
  'PRODUCT': 2,
  'TOUR': 3
}
